import './voucher-global-header.css';
import { Col, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { OutboundLink } from 'react-ga';
import { IAnalyticsAction, IApplicationState } from '../../store';
import { GoogleTagManagerEvents } from '../../helpers/googleTagManager';
import { useDispatch, useSelector } from 'react-redux';
import RedeemLocationsPopup from '../redeem-locations-popup/RedeemLocationsPopup';
import { blackFridayPromo, isFeatureEnabled, KnownFlag } from '../../store/featureFlags';
import Heading from '../heading/heading';

const VoucherGlobalHeader = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //find the language for building a url link to the global website for terms & conditions page
    const selectedLanguage = useSelector((state: IApplicationState) => state.intl.selectedLanguage);
    const globalWebsiteUrl = useSelector((state: IApplicationState) => state.appSettings.globalWebsiteUrl);
    const termsUrl = `${globalWebsiteUrl}/${selectedLanguage.globalWebsiteLangCode || 'en'}/terms-of-service`;

    //translated strings / content
    const mainDescription = t('globalGiftVouchers.header.description');
    const termsLabel = t('globalGiftVouchers.header.termsAndConditions');

    const featureFlags = useSelector((state: IApplicationState) => state.featureFlags);
    const blackFridayEnabled = isFeatureEnabled(featureFlags, KnownFlag.blackFriday);
    // The banner only shows while a gift voucher discount is live, so it never advertises a discount that isn't applied.
    const discountPercentage = useSelector((state: IApplicationState) => state.giftVoucher.configDetails?.activeDiscount?.discountPercentage);
    const blackFridayHeader = t('globalGiftVouchers.blackFriday.heading', { percentage: blackFridayPromo.percentage });
    const blackFridayBody = t('globalGiftVouchers.blackFriday.body');
    const blackFridayTerms = t('globalGiftVouchers.blackFriday.termsAndConditions');
    const blackFridayTermsUrl = `${globalWebsiteUrl}/${selectedLanguage.globalWebsiteLangCode || 'en'}/black-friday-terms-and-conditions#3pzmjOuyHutqj8xLP27BJg`;

    return (
        <React.Fragment>
            <Col>
                <Row>
                    <Typography.Text>
                        {mainDescription}
                    </Typography.Text>
                </Row>
                <Row>
                    <OutboundLink
                        eventLabel="Navigate to Main Site"
                        rel="noopener noreferrer"
                        title={termsLabel}
                        to={termsUrl}
                        target="_blank"
                        trackerNames={['zerolatency']}
                        onClick={() => {
                            dispatch({
                                type: 'ANALYTICS_EVENT',
                                googleTagManagerEvent: GoogleTagManagerEvents.GlobalGifts_TermsAndConditionsLinkClicked(),
                            } as IAnalyticsAction);
                        }}
                        className="logo"
                    >
                        {termsLabel}
                        </OutboundLink>
                </Row>
                {blackFridayEnabled && !!discountPercentage &&
                <Row justify="center" className="bf-container">
                    <Col>
                        <Row justify="center">
                            <Heading className="bf-heading">
                                {blackFridayHeader}
                            </Heading>
                        </Row>
                        <Row justify="center">
                            <Typography.Text className="bf-body">
                                {blackFridayBody}
                            </Typography.Text>
                        </Row>
                        <Row justify="center">
                            <OutboundLink
                                eventLabel="Navigate to Main Site"
                                rel="noopener noreferrer"
                                title={blackFridayTerms}
                                to={blackFridayTermsUrl}
                                target="_blank"
                                trackerNames={['zerolatency']}
                                onClick={() => {
                                    dispatch({
                                        type: 'ANALYTICS_EVENT',
                                        googleTagManagerEvent: GoogleTagManagerEvents.GlobalGifts_BlackFridayTermsAndConditionsLinkClicked(),
                                    } as IAnalyticsAction);
                                }}
                                className="logo"
                            >
                                {blackFridayTerms}
                            </OutboundLink>
                        </Row>
                    </Col>
                </Row>
                }
                <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                    <RedeemLocationsPopup />
                </Row>
            </Col>
        </React.Fragment>
    );
};

export default VoucherGlobalHeader;
